export default "__VITE_ASSET__BJY1OXaZ__"